import ProjectDetails from './ProjectDetailsContainer';

export default ProjectDetails;
